import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { LoadingService } from '@mds/ngx-core';
import { EMPTY, finalize, first } from 'rxjs';
import { DriverResponse, DriversClient } from '../../shared';

export const driverResolver: ResolveFn<DriverResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const client = inject(DriversClient);
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  const driverId = Number(route.paramMap.get('driverId'));

  if (Number.isNaN(driverId)) {
    void router.navigate(['drivers']);
    return EMPTY;
  }

  loadingService.start();

  return client.getDriver(driverId).pipe(
    first(),
    finalize(() => loadingService.end()),
  );
};
